import { render, staticRenderFns } from "./flickr.vue?vue&type=template&id=1f7fda7a&scoped=true"
import script from "./flickr.vue?vue&type=script&lang=js"
export * from "./flickr.vue?vue&type=script&lang=js"
import style0 from "./flickr.vue?vue&type=style&index=0&id=1f7fda7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7fda7a",
  null
  
)

export default component.exports